const textProps = {
  src: require("assets/img/new-york-city.jpg").default,
  size: "lg",
};
export default textProps;
